import Vue from 'vue'
import Vuex from 'vuex'
import { cloak } from '../keecloak'
import { error } from 'vue-error-display'
import { i18n } from '../i18n'
import { projectStore } from "./project"
import { configurationStore } from "./configuration"

Vue.use(Vuex)

export const fetchAuth = (input, init = {}) => {
  init.headers = init.headers || {}
  return new Promise((resolve, reject) => {
    const f = () =>
      fetch(input, {
        ...init,
        headers: {
          ...init.headers,
          Authorization: cloak.token && 'Bearer ' + cloak.token,
          'Accept-Language': cloak.userInfo && cloak.userInfo.locale,
        },
      })
        .then((response) => {
          if (!response.ok) {
            response.json().then(jsonRes => {
              var message = alertError(response.status, jsonRes)
              reject(
                new Error(
                  'Wrong Status Code. Server responded with ' +
                  response.status +
                  '. Message: ' + response.statusText + " " + message
                )
              )
            }).catch(err => {
              reject(
                new Error(
                  'Wrong Status Code. Server responded with ' +
                  response.status +
                  '. Message: ' +
                  response.statusText + " " + err
                )
              )
            })
          } else resolve(response)
        })
        .catch((err) => {
          error({
            id: 'warning_foo',
            type: 'error',
            title: i18n.t('error.default'),
            message: err,
            clickAway: true,
          })
          reject(err)
        })
    f()
  })
}

const alertError = (status, jsonRes) => {
  var message = ''

  if (status == 500) message = i18n.t('error.500')
  if (status == 401) message = i18n.t('error.401')
  if (status == 404) message = i18n.t('error.404')

  message += " " + (jsonRes.message ? jsonRes.message : '')

  error({
    id: 'warning_foo',
    type: 'error',
    title: i18n.t('error.default'),
    message: message,
    clickAway: true,
  })
}

export const store = new Vuex.Store({
  strict: process.env.NODE_ENV == 'production',

  modules: {
    projects: projectStore,
    configurations: configurationStore,
  },

  state: {
    modules: null,
    columnTypes: null
  },

  getters: {
    projectNumber: (state) => state.projects.project && +state.projects.project.number,
    configurationIndex: (state) => state.configurations.configuration && +state.configurations.configuration.index
  },

  mutations: {
    setModules: (state, modules) => state.modules = modules,
    setColumnTypes: (state, columnTypes) => state.columnTypes = columnTypes,
  },

  actions: {
    async loadModules({ state, commit }) {
      if (state.modules != null) return
      const response = await fetchAuth(`${process.env.VUE_APP_API}/modules`)
      commit('setModules', await response.json())
    },
    async loadColumnTypes({ state, commit }) {
      if (state.columnTypes != null) return
      const response = await fetchAuth(`${process.env.VUE_APP_API}/column-types`)
      commit('setColumnTypes', await response.json())
    }
  }
})

store.watch(state => state.configurations.configuration, (configuration, previousConfiguration) => {
  if (previousConfiguration == null) return
  store.dispatch("configurations/saveConfiguration").then(async () => {
    return Promise.all([
      store.dispatch("configurations/loadEmptyModulePlacements"),
      store.dispatch("configurations/validateFeedIn"),
      store.dispatch("configurations/loadRequiredFuseBoxes"),
      store.dispatch("configurations/generateBom"),
    ])
  })
}, { deep: true })

store.watch(state => state.configurations.configurationAmounts.map(({ amount }) => amount), (current, previous) => {
  Promise.all(current.map((amount, index) => {
    if (previous.length === 0) return false
    if (amount !== previous[index]) {
      return store.dispatch("configurations/saveConfiguration", index).then(() => true)
    }
    return false
  })).then(async (results) => {
    if (results.every(result => !result)) return
    await store.dispatch("projects/generateBom")
  })
}, { deep: true })
